import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  children,
  size = 'md',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-lg sm:text-2xl' : 'px-6 py-4 text-base sm:text-lg';
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`group inline-flex items-center justify-center gap-3 rounded-md bg-grass font-extrabold uppercase tracking-tight text-white shadow-[0_8px_0_0_#0a6b2d] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#119b44] hover:shadow-[0_10px_0_0_#0a6b2d] active:translate-y-1 active:shadow-[0_3px_0_0_#0a6b2d] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-grass ${sizing} ${className}`} data-id="element-64" data-mp="qjs9zfb3r77q">
      <span data-id="element-65" data-mp="35xxsmqt5qpta">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-66" data-mp="35yqq116882yr" />
    </a>;
}